/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { graphManager } from '../../../GraphManager';
import Divider from '@mui/material/Divider';
import DialogButton from '../../utils/DialogButton';

export default class DeleteCellContentDialog extends React.Component {
	static propTypes = {
		open: PropTypes.bool.isRequired,
		close: PropTypes.func.isRequired,
	}
	constructor(props) {
		super(props);

		this.state = {
			type: 'values',
		};
	}

	handleCancel = () => {
		this.props.close();
	};

	handleClose = () => {
		this.props.close();

		const sheetView = graphManager.getActiveSheetView();
		if (sheetView) {
			sheetView.deleteCellContent(graphManager.getGraphEditor().getGraphViewer(), this.state.type);
		}
	};

	render() {
		if (!this.props.open) {
			return null
		}
		return (
			<div>
				<Dialog open>
					<DialogTitle>
						<FormattedMessage
							id="DialogDeleteCellContent.Title"
							defaultMessage="Delete Cell Content"
						/>
					</DialogTitle>
					<DialogContent
						style={{
							minWidth: '200px',
						}}
					>
						<RadioGroup
							name="type"
							value={this.state.type}
							onChange={(event, state) => { this.setState({ type: state }); }}
							style={{
								marginTop: '20px',
							}}
						>
							<FormControlLabel
								value="all"
								control={<Radio />}
								label={<FormattedMessage id="DialogDeleteCellContent.Complete" defaultMessage="Complete" />}
							/>
							<FormControlLabel
								value="values"
								control={<Radio />}
								label={<FormattedMessage id="DialogDeleteCellContent.Values" defaultMessage="Values" />}
							/>
							<FormControlLabel
								value="formats"
								control={<Radio />}
								label={<FormattedMessage id="DialogDeleteCellContent.Formats" defaultMessage="Formats" />}
							/>
						</RadioGroup>
					</DialogContent>
					<Divider/>
					<DialogActions>
						<DialogButton
							margin
							onClick={this.handleCancel}
						>
							<FormattedMessage
								id="Dialog.Cancel"
								defaultMessage="Cancel"
							/>
						</DialogButton>
						<DialogButton
							margin
							onClick={this.handleClose}
							defaultButton
						>
							<FormattedMessage
								id="Dialog.OK"
								defaultMessage="OK"
							/>
						</DialogButton>
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}
